// extracted by mini-css-extract-plugin
module.exports = {"cornerSprite":"style__cornerSprite__xlrQJ","sideSprite":"style__sideSprite__81hi-","middleSprite":"style__middleSprite__QDbdG"};